import { FolderAddOutlined, ShrinkOutlined } from '@ant-design/icons';
import { Badge, Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface MinimizedDraftButtonProps {
  onClick: () => void;
}

export default function MinimizedDraftButton({
  onClick,
}: MinimizedDraftButtonProps) {
  const { t } = useTranslation(['ajout_dossier']);
  const label = t('ajout_dossier:minimized_entry');

  return (
    <Button
      onClick={onClick}
      aria-label={label}
      icon={
        <Badge
          dot
          data-testid="minimized-draft-badge"
          className="[&_.ant-badge-dot]:!bg-orange-particuliers-6"
        >
          <FolderAddOutlined className="text-bleu-hellio text-lg" />
        </Badge>
      }
      size="large"
      className="fixed bottom-0 right-4 z-[1040] !bg-white !border !border-color-border !rounded-lg shadow-md h-14 text-bleu-hellio hover:!text-bleu-hellio-600 hover:!border-bleu-hellio-500 transition-colors cursor-pointer [&_.ant-btn-icon]:flex"
    >
      <span className="flex items-center justify-between font-semibold ml-2">
        {label}
        <ShrinkOutlined className="ml-2 text-gris-hellio" />
      </span>
    </Button>
  );
}
